import React, {useState} from 'react';
import './RegisterCode.css';
import InputPin from "../../../Components/InputPin/InputPin";
import axios from "axios";
import {useNavigate} from "react-router-dom";

const RegisterCode = ({ email, isModalOpen }) => {

    const navigate = useNavigate();

    const [gameEnterCode, setGameEnterCode] = useState(null);
    const [gameOpenSuccess, setGameOpenSuccess] = useState('');
    const [gameOpenError, setGameOpenError] = useState(null);

    const closePin = () => {
        isModalOpen(false);
        // navigate('/login');
    }

    const verifyCode = () => {
        let data = {};
        data['email'] = email;
        data['code'] = gameEnterCode;

        axios.post(`/api/activate/`, data, {headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
                'X-CSRFToken': getCookie('csrftoken'),
                'Access-Control-Allow-Headers': 'X-CSRFToken'
            }, withCredentials: true})
            .then(res => {
                console.log(res);
                // setGameOpenSuccess('Аккаунт активирован!');
                navigate("/profile", {replace: true});
            })
            .catch(e => {
                // console.log('Код неверный');
                if (e.status === 403) {
                    setGameOpenError('Слишком много неверных попыток. Попробуйте через час');
                }
                if (e.status === 400) {
                    setGameOpenError('Неверный или истекший код');
                }
                // setGameOpenError('Неверный код');
            })
    }


    return (
        <div className={'pin-page-container'}>
            <div className={'reg-pin-container'}>

                <div className={'reg-pin-close-button'}>
                    <svg x="0px" y="0px" viewBox="2.5 2.5 19 19" fill="none" xmlns="http://www.w3.org/2000/svg"
                         onClick={() => closePin()}>
                        <path d="M5 5L19 19M5 19L19 5" stroke="#000000" stroke-width="2" stroke-linecap="round"
                              stroke-linejoin="round"/>
                    </svg>
                </div>

                {/*<div className={'game-pin-qr'}></div>*/}
                <div className={'reg-pin-title'}>Код отправлен на почту {email}</div>
                <p className={'reg-pin-title-smaller'}>Письмо может попасть в спам</p>
                <div className={'game-pin-pin'}>
                    <InputPin serverCode={gameEnterCode} setCode={setGameEnterCode}/>
                </div>
                <div
                    className={`game-open-success ${gameOpenError ? 'game-open-error' : ''}`}>{gameOpenError ? gameOpenError : gameOpenSuccess}</div>
                <div className={'reg-open-button-pin'} onClick={() => verifyCode()}>
                    <p className={'reg-open-button-text'}>Подтвердить</p>
                </div>
            </div>
        </div>
    );
};

function getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

export default RegisterCode;